import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '../../../Authentication/components/hooks/useUserOrg';

export default function useEnhancedDeviceGroupAssignment() {
    const authenticatedApi = useAuthenticatedApi();
    const { orgId } = useUserOrg();

    const getDeviceAssignments = async (orgId: number) => {
        const response = await authenticatedApi.get(
            `${orgId}/device-management/assignments`,
        );
        return response.data;
    };

    const addDeviceAssignmentsForGallery = async (
        galleryId: number,
        deviceGroups: number[],
        crossOrgDeviceGroups?: { orgId: number; deviceGroups: number[] }[],
    ) => {
        // For now, we'll use the original API structure but with enhanced payload
        // In a full implementation, the backend would need to support cross-org assignments
        const response = await authenticatedApi.post(
            `/${orgId}/device-groups/assignments/gallery`,
            JSON.stringify({
                deviceGroups,
                galleryId,
                crossOrgDeviceGroups, // For global admins to assign device groups from other orgs
            }),
        );

        return response.data;
    };

    const listDeviceAssignmentsForGallery = async (
        galleryId: number,
        targetOrgId?: number,
    ) => {
        const queryOrgId = targetOrgId || orgId;
        const response = await authenticatedApi.get(
            `/${queryOrgId}/device-groups/assignments/gallery/${galleryId}`,
        );

        console.log(response.data);
        return response.data;
    };

    return {
        getDeviceAssignments,
        addDeviceAssignmentsForGallery,
        listDeviceAssignmentsForGallery,
    };
}
